// src/components/common/CustomSelectMenuItem.tsx - For use with CustomSelect
import React from 'react';

interface CustomSelectMenuItemProps {
  value: string;
  children: React.ReactNode;
  disabled?: boolean;
}

const CustomSelectMenuItem: React.FC<CustomSelectMenuItemProps> = ({
  value,
  children,
  disabled = false,
}) => {
  // This is a wrapper component that passes its props to CustomSelect
  // The actual rendering is handled by CustomSelect component
  return null; // This component doesn't render anything itself
};

export default CustomSelectMenuItem;
